import { combineReducers } from 'redux';

import { stocklistConstants } from '../constants';

export interface ListState {
  users?: any[];
  loading?: boolean;
  error?: Error;
}

const list = (state: ListState = {}, action): ListState => {
  switch (action.type) {
    case stocklistConstants.USER_LIST_REQUEST: {
      return {
        users: state.users,
        loading: true,
      };
    }
    case stocklistConstants.USER_LIST_SUCCESS: {
      return {
        users: action.users,
      };
    }
    case stocklistConstants.USER_LIST_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const view = (
  state = {
    userId: undefined,
  },
  action
) => {
  if (action.type === stocklistConstants.SET_VIEWING_USER) {
    return {
      userId: action.userId,
    };
  }

  return state;
};

export default combineReducers({
  list,
  view,
});
